import { Tooltip } from '@mantine/core'
import { isString, size } from 'lodash'
import React, { ReactElement } from 'react'

type TTruncate = {
  maxLength?: number
  children?: React.ReactNode
  suffix?: string
  showTooltip?: boolean
}
const Truncate = (props: TTruncate): ReactElement => {
  const { maxLength, children, suffix = '...', showTooltip = true } = props

  if (!children) {
    return <></>
  }

  if (!isString(children)) {
    return children as ReactElement
  }

  if (!maxLength || size(children) <= maxLength) {
    return <>{children}</>
  }

  const truncated = <div>{`${children.substring(0, maxLength)}${suffix}`}</div>

  return showTooltip ? (
    <Tooltip withArrow label={children} withinPortal>
      {truncated}
    </Tooltip>
  ) : (
    truncated
  )
}

export default Truncate
